import React, { useState, useEffect } from 'react';

function TodayStatsModal({ zoneId, zoneName, date, shift, onClose, onEmployeeClick }) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    setLoading(true);
    fetch(
      `/api/attendance?date=${date}&shift=${shift}&zone_id=${zoneId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      }
    )
      .then((r) => r.json())
      .then((data) => {
        setEmployees(data.employees || []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [zoneId, date, shift]);

  const getInitials = (fullName) => {
    if (!fullName) return '?';
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const STATUS_OPTIONS = [
    { value: 'work', label: '✅ На работе', short: 'На работе' },
    { value: 'sick', label: '🤒 Болеет', short: 'Болеет' },
    { value: 'absent', label: '❌ Не вышел', short: 'Не вышел' },
    { value: 'dayoff', label: '🏖 Выходной', short: 'Выходной' },
    { value: 'vacation', label: '🌴 Отпуск', short: 'Отпуск' }
  ];

  const getStatusLabel = (status) => {
    const opt = STATUS_OPTIONS.find((o) => o.value === status);
    return opt ? opt.label : status;
  };

  const filtered = filterStatus === 'all'
    ? employees
    : employees.filter((e) => e.status === filterStatus);

  const counts = {
    all: employees.length,
    work: employees.filter((e) => e.status === 'work').length,
    sick: employees.filter((e) => e.status === 'sick').length,
    absent: employees.filter((e) => e.status === 'absent').length,
    dayoff: employees.filter((e) => e.status === 'dayoff').length,
    vacation: employees.filter((e) => e.status === 'vacation').length
  };

  const formatDate = (d) => {
    if (!d) return '—';
    const dateOnly = d.toString().split('T')[0];
    const [y, m, day] = dateOnly.split('-');
    return `${day}.${m}.${y}`;
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>
            📊 Явка за {formatDate(date)} — {zoneName} (
            {shift === 'day' ? '☀️ День' : '🌙 Ночь'})
          </h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {/* Фильтры */}
          <div className="today-stats-filters">
            <button
              className={`stats-filter-btn ${filterStatus === 'all' ? 'active' : ''}`}
              onClick={() => setFilterStatus('all')}
            >
              Все ({counts.all})
            </button>
            <button
              className={`stats-filter-btn stat-work ${filterStatus === 'work' ? 'active' : ''}`}
              onClick={() => setFilterStatus('work')}
            >
              ✅ На работе ({counts.work})
            </button>
            <button
              className={`stats-filter-btn stat-sick ${filterStatus === 'sick' ? 'active' : ''}`}
              onClick={() => setFilterStatus('sick')}
            >
              🤒 Болеет ({counts.sick})
            </button>
            <button
              className={`stats-filter-btn stat-absent ${filterStatus === 'absent' ? 'active' : ''}`}
              onClick={() => setFilterStatus('absent')}
            >
              ❌ Не вышел ({counts.absent})
            </button>
            <button
              className={`stats-filter-btn stat-dayoff ${filterStatus === 'dayoff' ? 'active' : ''}`}
              onClick={() => setFilterStatus('dayoff')}
            >
              🏖 Выходной ({counts.dayoff})
            </button>
            <button
              className={`stats-filter-btn stat-vacation ${filterStatus === 'vacation' ? 'active' : ''}`}
              onClick={() => setFilterStatus('vacation')}
            >
              🌴 Отпуск ({counts.vacation})
            </button>
          </div>

          {loading ? (
            <div className="empty" style={{ padding: '30px' }}>⏳ Загрузка...</div>
          ) : filtered.length === 0 ? (
            <div className="empty" style={{ padding: '30px' }}>
              Нет сотрудников с этим статусом
            </div>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th className="col-tab">Табель</th>
                  <th>ФИО</th>
                  <th>Должность</th>
                  <th>Статус</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((emp) => (
                  <tr
                    key={emp.employee_id}
                    onClick={() => onEmployeeClick(emp)}
                    style={{ cursor: 'pointer' }}
                  >
                    <td className="col-tab-value">{emp.tab_number || '—'}</td>
                    <td className="emp-name">
                      <div className="emp-name-cell">
                        <div className={`emp-avatar ${emp.gender === 'м' ? 'male' : 'female'}`}>
                          {getInitials(emp.full_name)}
                        </div>
                        {emp.full_name}
                      </div>
                    </td>
                    <td>
                      <span className="role-label">{emp.role_name || '—'}</span>
                    </td>
                    <td>
                      <span className={`today-stat-item stat-${emp.status}`}>
                        {getStatusLabel(emp.status)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="modal-footer">
          <div className="modal-footer-right">
            <button className="btn-cancel" onClick={onClose}>Закрыть</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TodayStatsModal;